import React, { useState } from 'react';

import cn from 'classnames';
import { useForm } from 'react-hook-form';
import { isEmail } from 'react-multi-email';

import { ALERT_ERROR } from 'components/AlertNotifications/AlertNotificationProvider';
import useAlertNotification from 'components/AlertNotifications/useAlertNotification';
import SpinnerIcon from 'design/Icons/SpinnerIcon';
import getErrorMessage from 'utils/getErrorMessage';
import { apiPost } from 'utils/request';

import styles from '../SignIn.module.scss';

interface FormData {
  loginName: string;
}

const SSOLogin = () => {
  const { register, handleSubmit } = useForm<FormData>();
  const [pending, setPending] = useState(false);
  const notify = useAlertNotification();

  const onSubmit = async ({ loginName }: FormData) => {
    if (pending) return;
    try {
      setPending(true);
      const name = isEmail(loginName) ? loginName : loginName.toLowerCase();
      const res = await apiPost(`/auth/saml`, {
        loginName: name,
      });
      window.open(res.redirectUrl, '_self');
    } catch (e) {
      console.log(e);
      const message = getErrorMessage(e);
      notify('SAML SSO login error', message, ALERT_ERROR);
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="panel user-auth-card">
      <div className="panel-header">
        <h2>Log in to your account</h2>
      </div>
      <div className="instructions mb-4">
        <p>
          To log in using SAML SSO, your account must first be configured for
          <button className="p-sso-login-btn p-link-btn">SAML SSO access.</button>
        </p>

        <p>
          If your account is already set up, please enter your username or email address
          to continue.
        </p>
      </div>
      <div className="panel-body">
        <form>
          <div className="form-field form-field-lg">
            <div className="input">
              <label>Username/Email:</label>
              <input
                type="text"
                autoFocus
                {...register('loginName', { required: true })}
                // style={{ textTransform: 'lowercase' }}
              />
            </div>
          </div>
          <div className={styles.emptySpace} />
          <div className="form-field mb-0">
            <button
              type="submit"
              className={cn('btn btn-primary btn-lg', styles.submitBtn)}
              onClick={handleSubmit(onSubmit)}
            >
              {pending && <SpinnerIcon className={styles.spinner} />}
              Log in
            </button>
          </div>
        </form>
      </div>
      <div className="panel-footer"></div>
    </div>
  );
};

export default SSOLogin;
